import React from 'react';

export const ORIGENES = [
  { value: 'web', label: 'Formulario web', className: 'bg-slate-500/20 text-slate-300' },
  { value: 'comparador', label: 'Comparador', className: 'bg-cyan-500/20 text-cyan-300' },
  { value: 'chat', label: 'Chat IA', className: 'bg-fuchsia-500/20 text-fuchsia-300' },
];

export const OrigenTag = ({ origen }) => {
  const o = ORIGENES.find((x) => x.value === (origen || 'web')) || ORIGENES[0];
  return <span data-testid="lead-origen-tag" className={`inline-block rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${o.className}`}>{o.label}</span>;
};
